<script setup>
import { ref, defineProps, defineEmits } from "vue"

defineProps({
    show: {
        type: Boolean,
        default: false
    },
    data: {
        type: Array,
        required: true
    },
    title: {
        type: String,
        default: 'Mời chọn'
    }
});

const emit = defineEmits(["callApi", "callBack"]);

const submit = (value) => {
    emit('callApi', value);
    close();
}

const close = () => {
    emit('callBack', false);
};

</script>
<template>
    <transition name="slide-up">
        <div v-if="show" class="absolute bottom-0 w-full h-auto min-h-20 float-end bg-white rounded-t-3xl overflow-hidden p-6 animation_up">
            <div class="w-full flex flex-col justify-start items-center">
                <div class="text-xl font-bold text-center w-full pb-4">
                    {{ title }}
                </div>
                <div v-for="(item, index) in data" :key="index" @click="submit(item)" class="w-full text-left px-4 pb-4">
                    {{ item.name }}
                    <input type="radio" :value="item.id" v-model="model" class="hidden">
                </div>
            </div>
        </div>
    </transition>
</template>